import { FC } from 'react';

const IconTransfers: FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.042 8.992h13.917a1 1 0 0 0 .799-1.601L13.785 2.11l-1.6 1.203 2.77 3.679H5.62a2 2 0 0 0-1.551.739zm3.175 8.883-3.974-5.281a1 1 0 0 1 .799-1.602h14l-1.026 1.262a2 2 0 0 1-1.552.738H5.046l2.769 3.68z"
      clipRule="evenodd"
    />
  </svg>
);

export { IconTransfers };
